import React, { useState, useEffect } from 'react';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Button,
  useToast,
} from '@chakra-ui/react';

interface HistorialCambio {
  id: string;
  idClaveCatastral: string;
  idPropietarioAnterior: string;
  idPropietarioNuevo: string;
  fechaCambio: string;
  usuario: string;
}

interface HistorialModalProps {
  id: string; // ID para la consulta
  isOpen: boolean; // Controla la apertura del modal
  onClose: () => void; // Callback para cerrar el modal
}

const HistorialModal: React.FC<HistorialModalProps> = ({ id, isOpen, onClose }) => {
  const [historial, setHistorial] = useState<HistorialCambio[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (isOpen) {
      fetchHistorial();
    }
  }, [isOpen]);

  const fetchHistorial = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/HistoricoCambioPredio/${id}`);
      if (!response.ok) {
        throw new Error('Error al obtener los datos del historial');
      }
      const data = await response.json();
      setHistorial(data);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo cargar el historial de cambios.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Historial de Propietarios</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Spinner size="xl" />
          ) : historial.length > 0 ? (
            <Table variant="striped" colorScheme="gray">
              <Thead>
                <Tr>
                  <Th>ID Propietario Anterior</Th>
                  <Th>ID Propietario Nuevo</Th>
                  <Th>Fecha</Th>
                  <Th>Usuario</Th>
                </Tr>
              </Thead>
              <Tbody>
                {historial.map((item) => (
                  <Tr key={item.id}>
                  
                    <Td>{item.idPropietarioAnterior}</Td>
                    <Td>{item.idPropietarioNuevo}</Td>
                    <Td>{new Date(item.fechaCambio).toLocaleString()}</Td>
                    <Td>{item.usuario}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          ) : (
            <Box>No se encontraron cambios registrados.</Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HistorialModal;
